import { Alert, Box, Button } from '@mui/material';
import { BrandLogo } from './ui/BrandLogo';

interface AuthenticationErrorProps {
  message: string;
  onRetry: () => Promise<void>;
  onSignOut: () => Promise<void>;
}

export function AuthenticationError({
  message,
  onRetry,
  onSignOut,
}: AuthenticationErrorProps) {
  return (
    <Box
      component="main"
      sx={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', p: 2 }}
    >
      <Box sx={{ width: '100%', maxWidth: 440, textAlign: 'center' }}>
        <BrandLogo sx={{ fontSize: 36, mb: 4 }} />
        <Alert severity="error" role="alert" sx={{ mb: 2 }}>
          {message}
        </Alert>
        <Button
          variant="contained"
          fullWidth
          onClick={() => {
            void onRetry();
          }}
          sx={{ mb: 1 }}
        >
          Try again
        </Button>
        <Button
          fullWidth
          onClick={() => {
            void onSignOut();
          }}
        >
          Use another account
        </Button>
      </Box>
    </Box>
  );
}
